export const TokenKey = 'token';
export const RefreshToken = 'refresh_token';
export const UsernameKey = 'username';
export const RoleType = 'roleType';
export const UserTabbar = 'userTabbar';
export const FailRedirect = '/pages/login/login';
export const SuccessRedirect = '/pages/tabbar-page/index-tabbar/index-tabbar';
export const customerIdKey = 'customerId';